
import React from 'react';
import { Recycle, Coins, Zap, FileText, Package, Fuel, Droplets } from 'lucide-react';
import ValorisationServiceCard from './ValorisationServiceCard';

const ValorisationServicesGrid = () => {
  const valorisationServices = [
    {
      title: "Métaux Ferreux",
      description: "Recyclage et valorisation de la ferraille, fonte, acier. Rachat au meilleur prix.",
      icon: Recycle,
      path: "/valorisation/metaux-ferreux",
      color: "bg-fabre-green",
      benefits: ["Économie d'énergie 70%", "Réduction CO2", "Valorisation économique"]
    },
    {
      title: "Métaux Non Ferreux", 
      description: "Aluminium, cuivre, zinc, laiton, inox. Collecte et rachat spécialisé.",
      icon: Coins,
      path: "/valorisation/metaux-non-ferreux", 
      color: "bg-fabre-teal",
      benefits: ["Économie d'énergie 95%", "Ressources préservées", "Haute valeur ajoutée"]
    },
    {
      title: "DEEE",
      description: "Déchets d'équipements électriques et électroniques. Traitement certifié.",
      icon: Zap,
      path: "/valorisation/deee",
      color: "bg-fabre-darkgreen", 
      benefits: ["Traçabilité complète", "Conformité réglementaire", "Dépollution sécurisée"]
    },
    {
      title: "Papiers Cartons",
      description: "Collecte et recyclage de tous types de papiers et cartons d'emballage.",
      icon: FileText,
      path: "/valorisation/papiers-cartons",
      color: "bg-fabre-gray",
      benefits: ["Économie d'eau", "Préservation forêts", "Économie circulaire"]
    },
    {
      title: "DIB",
      description: "Déchets industriels banals. Gestion complète pour entreprises et collectivités.",
      icon: Package,
      path: "/valorisation/dib",
      color: "bg-fabre-teal",
      benefits: ["Conformité réglementaire", "Optimisation coûts", "Traçabilité complète"]
    },
    {
      title: "Huiles Minérales", 
      description: "Collecte et traitement des huiles usagées industrielles et automobiles.",
      icon: Fuel,
      path: "/services/huiles-minerales",
      color: "bg-fabre-darkgreen",
      benefits: ["Régénération possible", "Protection environnement", "Conformité légale"]
    },
    {
      title: "Huiles Alimentaires",
      description: "Valorisation des huiles de friture et graisses alimentaires usagées.",
      icon: Droplets, 
      path: "/services/huiles-alimentaires",
      color: "bg-fabre-green",
      benefits: ["Biocarburant", "Économie circulaire", "Réduction déchets"]
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-fabre-gray mb-3 md:mb-4">
            Nos Services de Valorisation
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Découvrez notre expertise dans la valorisation de différents types de déchets pour une économie circulaire durable
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto">
          {valorisationServices.map((service) => (
            <ValorisationServiceCard
              key={service.path}
              title={service.title}
              description={service.description}
              icon={service.icon}
              path={service.path}
              color={service.color}
              benefits={service.benefits}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValorisationServicesGrid;
